import { NodeTaskData } from "../../../nodes/mapper";
import { DynamicTaskDef } from "types/TaskType";
import LinkIcon from "./icons/LinkIcon";

export const DynamicTask = ({
  nodeData,
}: {
  nodeData: NodeTaskData<DynamicTaskDef>;
}) => {
  const isDynamicSubWorkflow =
    nodeData.task.inputParameters.taskToExecute === "SUB_WORKFLOW";
  const subWorkflowId = nodeData.outputData?.subWorkflowId as string;

  return isDynamicSubWorkflow && subWorkflowId ? (
    <div
      style={{
        marginTop: 2,
        display: "flex",
        alignItems: "center",
        gap: 2,
      }}
    >
      <LinkIcon />
      <a
        href={`/execution/${subWorkflowId}`}
        style={{ textDecoration: "none", color: "cyan" }}
        target="_blank"
        rel="noreferrer"
      >
        {subWorkflowId}
      </a>
    </div>
  ) : null;
};
